import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=11aad4a5&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11aad4a5')) {
      api.createRecord('11aad4a5', component.options)
    } else {
      api.reload('11aad4a5', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=11aad4a5&", function () {
      api.rerender('11aad4a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/icon.vue"
export default component.exports